import React from "react";
import moment from "moment-timezone";

class AttendanceItem extends React.Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(event) {
		this.props.handleConfirm(this.props);
	}

	allowCheckin() {
		const now = this.props.currentMoment.tz("America/Los_Angeles").unix();
		const startAllow = moment(this.props.startTime).subtract(10, 'minutes').tz("America/Los_Angeles").unix();
		const endAllow = moment(this.props.startTime).add(10, 'minutes').tz("America/Los_Angeles").unix();
		return (now > startAllow && now < endAllow);
	}

	checkinCountdown() {
		const now = this.props.currentMoment.tz("America/Los_Angeles");
		const startAllow = moment(this.props.startTime).subtract(10, 'minutes').tz("America/Los_Angeles");
		return {
			status: now.isBefore(startAllow),
			message: moment.duration(startAllow.diff(now)).humanize()
		};
	}

	render() {
		const isCheckedIn = this.props.isCheckedIn;
		const allowCheckin = this.allowCheckin();
		let button;
		if (isCheckedIn) {
			button = <button disabled="disabled">Checked In</button>;
		} else {
			button = <button onClick={this.handleClick}>Check In</button>;
		}

		if ( !allowCheckin ) {
			let countdown = this.checkinCountdown();

			if ( countdown.status ) {
				button = <button disabled="disabled">open in {countdown.message}</button>;
			} else {
				button = <button disabled="disabled">Check in Closed</button>;
			}
		}

		return (
			<li>
				<div className="class-student">
					{this.props.lastName}, {this.props.firstName}
				</div>
				<div className="class-student-action">{button}</div>
			</li>
		);
	}
}

export default AttendanceItem;



// WEBPACK FOOTER //
// ./src/components/AttendanceItem.js